export const ArrowDropdownFillIcon = ({ className }) => {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 11.6668L6.66669 8.3335H13.3334L10 11.6668Z" fill="#697586" />
    </svg>
  )
}